import { Routes } from '@angular/router';
import { actifResolver } from 'app/shared/actif.resolver';
import { PrincipauxResolver } from 'app/shared/principaux.resolver';
import { ActifsComponent } from './actifs.component';
import { MurActifComponent } from './mur-actif/mur-actif.component';

export default [
    {
        path: '',
        component: ActifsComponent,
    },
    {
        path: ':id/:isin',
        resolve: {
            actif: actifResolver,
            principaux: PrincipauxResolver,
        },
        component: MurActifComponent,
    },
] as Routes;
